import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

export interface msgListJson {
  classname?: string;
  status?: number;
  nickName?: string;
  msg?: string;
  icon?: string;
  giftIcon?: string;
  animation_file?: string;
  animation_type?: string;
  balance?: number;
  combo_num?: any;
  count?: any;
  full_screen?: string;
  full_effect_url?: string;
  gift_icon?: string;
  gift_id?: number;
  gift_name?: string;
  head_img?: string;
  nickname?: string;
  uid?: number;
  scene_id?: number;
  scene_type?: number;
  t_head_img?: string;
  t_nickname?: string;
  t_uid?: number;
  from?: string;
  to?: number;
  mid?: number;
  time?: number;
  isPlay: boolean;
  visible?: boolean;
}

export interface msgListJsons {
  classname?: string;
  status?: number;
  nickName?: string;
  msg?: string;
  icon?: string;
  giftIcon?: string;
  isComBo?: boolean;
  animation_file?: string;
  animation_type?: string;
  balance?: number;
  combo_num?: string;
  count?: string;
  full_screen?: string;
  full_effect_url?: string;
  gift_icon?: string;
  gift_id?: number;
  gift_name?: string;
  head_img?: string;
  nickname?: string;
  uid?: number;
  scene_id?: number;
  scene_type?: number;
  t_head_img?: string;
  t_nickname?: string;
  t_uid?: number;
  from?: string;
  to?: number;
  mid?: number;
  time?: number;
  isPlay?: boolean;
  visible?: boolean;
}

export interface msgItemJson {
  msg?: string;
  uid?: number;
  nickName?: string;
}

export interface LiveState {
  breadCrumbState: string;
  isFollow: boolean;
  isOneEnter: boolean;
  msgList: msgListJson[];
  msgInfoItem?: msgListJsons;
  msgItem: msgItemJson;
  giftItem: msgListJson;
  isRefreshMuted: boolean;
  isMuted: boolean;
  recordVolume: number;
  volume: number;
  isBanFrame: boolean;
  isBanFrameUrl: string;
  isBanMsg?: boolean;
  isBanMsgTime?: number;
  isBanMsgStr?: string;
  isEndLive?: number;
  isBanLive?: boolean;
  isBanBlack?: boolean;
  isBanLiveRoom?: boolean;
  reloadTime?: number;
}

const localGameInfo = LocalStore.getValue<LiveState>('LIVE_STATE') || {};

export const liveInfo: LiveState = {
  breadCrumbState: '1',
  isFollow: true,
  isOneEnter: true,
  msgList: [],
  msgInfoItem: {},
  msgItem: {},
  giftItem: {
    isPlay: false
  },
  isRefreshMuted: true,
  isMuted: true,
  recordVolume: 50,
  volume: 50,
  isBanFrame: false,
  isBanFrameUrl: '',
  isBanMsg: undefined,
  isBanMsgTime: 0,
  isBanMsgStr: '',
  isEndLive: 0,
  isBanLive: undefined,
  isBanBlack: undefined,
  isBanLiveRoom: undefined,
  reloadTime: 0,
  ...localGameInfo
};

export const setLiveInfo: (payload: LiveState) => IAction<LiveState> = (payload: LiveState) => ({
  type: 'setLiveInfo',
  payload
});

const liveReducer: Reducer<LiveState, IAction<any>> = (state = liveInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setLiveInfo':
      LocalStore.setValue('LIVE_STATE', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default liveReducer;
